import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import AddColorModal from 'src/components/global-settings/AddColorModal'
import { createVehicleColor, getVehicleCreateOptions } from 'src/state/actions/vehicles'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {}
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    createVehicleColor: (name: string) => {
      return new Promise((approve, reject) => {
        dispatch(createVehicleColor(name)).then(() => {
          dispatch(getVehicleCreateOptions()).then(() => {
            approve()
          })
        })
      })
    },
    getVehicleCreateOptions: () => dispatch(getVehicleCreateOptions())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddColorModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/AddColorModal.ts